module.exports = __webpack_public_path__ + "static/media/vip-entry-locked.13bb5923.png";